import { useContext, useEffect, useState } from "react";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import InputFilterBox from "../InputFilterBox/web"
import { DataOptionsTypes } from "../types";
import { operation_type_id } from "../options";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getOptionsSelectedText } from "src/utils/Functions";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const OperationTypeFilter = () => {
    const { filters } = useFilters();
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const { country_code } = useContext(ConfigStateContext);
    const [operationTypeText, setOperationTypeText] = useState('Tipo de oferta');

    const operationTypeIdByCountry = operation_type_id.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : ""));
    const operationTypeList = operationTypeIdByCountry.map((type) => ({ text: type.text, value: type.value }))

    useEffect(() => {
        if (filters.operation_type_id) {
            const text = getOptionsSelectedText(operationTypeIdByCountry, filters?.operation_type_id)

            setOperationTypeText(text)
        } else {
            setOperationTypeText('Tipo de oferta')
        }
    }, [filters.operation_type_id])

    const handleOnChange = (value: DataOptionsTypes) => {
        const valuesToChange = {
            operation_type_id: value,
            minPrice: undefined,
            maxPrice: undefined
        }

        if (country_code !== 'CO' && value.value === 1) {
            const soldValue = {text: 'U$S', value: 1}

            valuesToChange["currencyID"] = soldValue;
            valuesToChange["m2Currency"] = soldValue;
        } else {
            const rentValue = {text: 'U$S', value: 1}

            valuesToChange["currencyID"] = rentValue;
            valuesToChange["m2Currency"] = rentValue;
        }

        changeFilters(valuesToChange);
    }

    return (
        <InputFilterBox
            active={true}
            label={operationTypeText}
            scrollable
        >
            <div className="optionList">
                {operationTypeList
                    .filter(val => country_code === "CO" ? val.text !== "Vacacional" : true)
                    .map((val, i) => (
                        <div key={val.text + "-" + i} className="optionList__option">
                            <input
                                type="radio"
                                className="radioCustomInput"
                                onChange={() => handleOnChange(val)}
                                name={"operation_type_id"}
                                id={val.text}
                                value={val.value}
                                checked={val.value === filters?.operation_type_id}
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    ))
                }
            </div>
        </InputFilterBox>
    )
}